export const USER_DATA_ENDPOINTS = {
  login: "login",
};
